export default {
  access_token: 'pk.eyJ1Ijoid2FzaGlndG9uZ29uY2FsdmVzIiwiYSI6ImNrYzR1ZjRjZzBiaXMycm1vNzh5dnZkMTYifQ.Hy7E2L6l3A-QFnQiJEvwJg',
  style: 'light'
};
